import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {find, get, isEmpty, merge} from 'lodash';

import Navigation from './Navigation';
import * as companyApi from '../../redux/actionCreators/async/companies';
import * as companyStore from '../../redux/actionCreators/sync/companies';
import UserMenu from '../admin/UserMenu';
import * as ui from '../../redux/actionCreators/sync/ui';
import * as contactApi from '../../redux/actionCreators/async/contacts';
import moment from 'moment';

import InfoModal from '../../common/components/f_InfoModal';

@connect((state) => ({
  contact: state.contactProfile,
  staticData: state.staticData,
  ui: state.ui,
  bqpMigrationFeature: state.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true,
  showBqpMigrationModal: true,
  bqpClientMigrationLabels    : state.labels.Client.BqpClientMigration,
}))
export default class ClientLanding extends Component {
  static propTypes = {
    dispatch : PropTypes.func.isRequired,
    contact : PropTypes.object.isRequired,
    staticData: PropTypes.object,
    bqpMigrationFeature : PropTypes.bool,
    bqpClientMigrationLabels     : PropTypes.object.isRequired,
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      showBqpMigrationModal: this.props.bqpMigrationFeature,
    };
  }

  componentDidMount() {
    this.sendBQPClientMigrationEmail();
  }

  componentDidUpdate() {
    this.sendBQPClientMigrationEmail();
  }

  // determine if the onboarding email has ever been sent, or it has been at least 2 days since the onboarding email has been sent
  checkSendBQPClientMigrationEmail () {
    if (this.props.contact.profile.lastBQPOnboardingEmailSentDate === null) {
      return true;
    }
    const dateSent = moment(this.props.contact.profile.lastBQPOnboardingEmailSentDate);
    const thresholdDays = 2; // send if we haven't sent for 2 days
    const threshold = moment(new Date()).subtract(thresholdDays, 'days');

    return threshold > dateSent;
  }

  // Send migration email if we haven't sent it in 2 days
  sendBQPClientMigrationEmail() {
    if (this.props.bqpMigrationFeature) {
      if (this.props.contact.profile) {
        if (this.checkSendBQPClientMigrationEmail()) {

          // update redux store with lastBQPOnboardingEmailSentDate
          const updatedContact = this.props.contact;
          updatedContact.profile.lastBQPOnboardingEmailSentDate = new Date();
          this.setState({contact: updatedContact});

          // update db with lastBQPOnboardingEmailSentDate
          this.props.dispatch(contactApi.updateContactOnboardingEmailDate(updatedContact, (err, data) => {
            if (err) {

              // eslint-disable-next-line no-console
              console.error(data);

              // eslint-disable-next-line no-console
              return console.error(err);

              // eslint-disable-next-line no-else-return
            } else {
              this.props.dispatch(ui.showSnackBar('Updated Contact:lastBQPOnboardingEmailSent'));
            }
          }));
        }
      }
    }
  }

  // save the fact that we've shown the migration modal in this session
  closeModal() {
    this.setState(merge(this.state, {showBqpMigrationModal: false}));
  }

  render() {
    const migrationText = this.props.bqpClientMigrationLabels.message;
    const migrationEmailLink = <span className='migration-modal-font-color'><a href='mailto:sales@wahve.com'>{this.props.bqpClientMigrationLabels.emailLinkText}</a></span>;
    const migrationModalEmailLink = <div className='migration-modal-font-color'><br /><a href='mailto:sales@wahve.com'>{this.props.bqpClientMigrationLabels.emailLinkText}</a></div>;

    return (
      <div className='client-landing content-container'>
        <UserMenu dispatch={this.props.dispatch}/>
        <Navigation location={this.props.location}/>
        { // send migration email?
          this.props.bqpMigrationFeature &&
          <div className='migration-info-section'>
            {migrationText}
            {migrationEmailLink}
          </div>
        }
        { // show migration modal?
          this.props.bqpMigrationFeature &&
          this.state.showBqpMigrationModal &&
          <div className='migration-modal-font-color'>
            <InfoModal
              buttonLabel={'close'}
              text={migrationText}
              children= {migrationModalEmailLink}
              cancelFunc={this.closeModal.bind(this)}
              transitionFunc={this.closeModal.bind(this)}
            />
          </div>
        }
        {
          this.props.children
        }
      </div>
    );
  }
}

export function OnEnterLoadCompanyContacts(store) {
  return (nextState, replace, done) => {
    const state = store.getState();
    if (isEmpty(state.companyContacts)) {
      const companyId = get(state, 'user.companyId');

      store.dispatch(companyApi.getCompanyContacts(companyId, (err, data) => {
        if (err || !data) {
          return done(err || new Error('No contact profile found.'));
        }
        const companyContacts = get(data, 'body.data.items', []);
        store.dispatch(companyStore.updateCompanyContacts(companyContacts));
        return done();
      }));
    }
    done();
  };
}



// WEBPACK FOOTER //
// ./shared/react/client/index.js